<template>
  <div class="flex flex-col gap-1">
    <div class="font-semibold">
      <span v-if="props.data.TenantName">{{ props.data.TenantName }}</span>
      <span v-if="props.data.TenantSurname">{{
        props.data.TenantSurname
      }}</span>
      <span> (Contract Id: {{ props.data.Id }} )</span>
    </div>
    <div class="text-sm text-gray-500">
      <span v-if="props.data.TenantIdNumber"
        >ID: {{ props.data.TenantIdNumber }}</span
      >
      <span
        v-if="props.data.TenantIdNumber && props.data.TenantCellPhoneNumber"
      >
        |
      </span>
      <span v-if="props.data.TenantCellPhoneNumber"
        >Cell: {{ props.data.TenantCellPhoneNumber }}</span
      >
    </div>
    <div
      v-if="props.data.OwnerName || props.data.OwnerSurname"
      class="text-sm text-gray-400"
    >
      Owner:
      <span v-if="props.data.OwnerName">{{ props.data.OwnerName }}</span>
      <span v-if="props.data.OwnerSurname">{{ props.data.OwnerSurname }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface AuxInputProps {
  data: unknown;
}

const props = defineProps<AuxInputProps>();
</script>

<style scoped></style>

